
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//     Runtime Version: 4.0.30319.42000
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export default class FormErrorMessages {
    static readonly firstName: string = "A First Name Is Required";
    static readonly lastName: string = "A Last Name Is Required";
    static readonly signature: string = "A Valid Signature Is Required";
    static readonly signatureDate: string = "A Signature Date Is Required";
    static readonly accountNumber: string = "Invalid Account Number";
    static readonly applicationNumber: string = "Invalid Application Number";
    static readonly streetNumber: string = "A Valid Street Number Is Required";
    static readonly streetDirection: string = "Select A Street Direction";
    static readonly streetName: string = "A Valid Street Name Is Required";
    static readonly streetType: string = "Select A Street Type";
    static readonly city: string = "A Valid City Is Required";
    static readonly state: string = "A State Is Required";
    static readonly zip: string = "A Zip Code Is Required";
    static readonly phone: string = "A Phone Number Is Required";
}